import { useEffect, useState } from "react";
import { Clock3, Wrench } from "lucide-react";
import { C, fonts } from "../../theme/tokens";

export function MaintenanceNotice({ t }) {
  return (
    <div role="alert" style={{ display: "flex", alignItems: "flex-start", gap: 10, margin: "0 0 18px", padding: "12px 14px", borderRadius: 12, border: `1px solid ${C.violetBright}66`, background: `${C.violetBright}14`, color: C.primary, textAlign: "left" }}>
      <Wrench size={17} color={C.violetBright} style={{ flexShrink: 0, marginTop: 2 }} />
      <div>
        <strong style={{ display: "block", color: C.violetBright, fontSize: 13.5 }}>{t.maintenance_title}</strong>
        <span style={{ display: "block", marginTop: 3, color: C.secondary, fontSize: 12.5, lineHeight: 1.45 }}>{t.maintenance_desc}</span>
      </div>
    </div>
  );
}

export function MaintenanceScreen({ t, endsAt, durationSeconds = 60 * 60 }) {
  const fallbackSeconds = Math.max(60, Number(durationSeconds) || 60 * 60);
  const getRemaining = () => {
    const endMs = Date.parse(endsAt || "");
    return Number.isFinite(endMs)
      ? Math.max(0, Math.ceil((endMs - Date.now()) / 1000))
      : fallbackSeconds;
  };
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemaining(getRemaining());
    }, 1000);
    return () => window.clearInterval(timer);
  }, [endsAt, fallbackSeconds]);

  const hours = String(Math.floor(remaining / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, "0");
  const seconds = String(remaining % 60).padStart(2, "0");

  return (
    <main style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, boxSizing: "border-box", color: C.primary, background: `radial-gradient(circle at 50% 20%, ${C.violetDeep}, transparent 44%), ${C.canvas}`, textAlign: "center" }}>
      <div style={{ maxWidth: 460 }}>
        <div style={{ width: 72, height: 72, margin: "0 auto 24px", display: "grid", placeItems: "center", borderRadius: 22, color: C.violetBright, background: `${C.violetBright}18`, border: `1px solid ${C.violetBright}44` }}>
          <Wrench size={30} />
        </div>
        <h1 style={{ margin: 0, fontFamily: fonts.display, fontSize: 30, lineHeight: 1.15 }}>{t.maintenance_title}</h1>
        <p style={{ margin: "14px auto 28px", color: C.secondary, lineHeight: 1.6 }}>{t.maintenance_desc}</p>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 10, color: C.violetBright }}>
          <Clock3 size={18} />
          <span style={{ fontFamily: fonts.display, fontWeight: 700, fontSize: 24, letterSpacing: "0.04em" }}>{hours}:{minutes}:{seconds}</span>
        </div>
        <div style={{ marginTop: 8, color: C.mutedB, fontSize: 12.5 }}>{t.maintenance_timer}</div>
      </div>
    </main>
  );
}